import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthContext.tsx';

export function RequireAgent({ children }: { children: React.ReactNode }): React.ReactElement {
  const { agent, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-[var(--color-muted)]">
        Loading…
      </div>
    );
  }

  if (!agent) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
